import { useState } from "react";

/**
 * Página que volta para a 1 quando o filtro muda.
 *
 * A página fica guardada junto da chave do filtro em que foi escolhida. Com outra
 * chave ela não vale mais, e a leitura devolve 1 sem precisar de efeito: um
 * `useEffect(() => setPage(1), [filtro])` pediria ao banco a página antiga do
 * filtro novo antes de corrigir, e ela pode nem existir.
 */
export function useResettingPage(filterKey: string): [number, (page: number) => void] {
  const [state, setState] = useState<{ key: string; page: number }>({
    key: filterKey,
    page: 1,
  });
  const page = state.key === filterKey ? state.page : 1;
  const setPage = (next: number) => setState({ key: filterKey, page: next });
  return [page, setPage];
}
